import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { ErrorAlert } from '../../../components/Alerts';
import { entityLocation } from '../../../utils/entity';
import * as Entities from '../../../constants/Entities';
import {
  UnitCreateType,
  useUnitCreateMutation,
} from '../../../__generated__/types';
import { UnitCreate, UnitCreateData } from './UnitCreate';
import { useBreadcrumb } from '../../../contexts/breadcrumb-context';
import { makeHierarchyBreadcrumb } from '../../../utils/breadcrumb';
import { useHeader } from '../../../contexts/header-context';

export const UnitCreateContainer: React.FC = () => {
  const { t } = useTranslation(['units', 'general']);
  const navigate = useNavigate();
  const location = useLocation();
  const { setTitle } = useHeader();

  const hierarchy = makeHierarchyBreadcrumb(
    [
      {
        type: Entities.UNIT,
        id: '/new',
        name: t('units:breadcrumb.create'),
      },
    ],
    t,
  );
  useBreadcrumb(hierarchy);

  useEffect(() => {
    setTitle({ main: t('units:breadcrumb.create') });
  }, [setTitle, t]);

  const [createUnit, { loading: loadingCreate, error: errorCreate }] =
    useUnitCreateMutation({
      onCompleted: (result) => {
        navigate(entityLocation(Entities.UNIT, result.createUnit?.id ?? ''));
      },
      onError: (error) => console.warn(error),
    });

  const handleDiscard = () => {
    navigate(
      location.pathname.substring(0, location.pathname.lastIndexOf('/')),
    );
  };

  const handleCreate = (inputData: UnitCreateData) => {
    const unitInput: UnitCreateType = {
      ...inputData,
      uris: inputData.uris.map((entry) => entry.uri),
    };
    return createUnit({
      variables: { unitInput },
    });
  };

  return (
    <>
      <UnitCreate
        loading={loadingCreate}
        onSubmit={handleCreate}
        onDiscard={handleDiscard}
      />
      <ErrorAlert
        title={t('general:errorAlert.title')}
        message={t('general:errorAlert.message')}
        errors={[errorCreate]}
      />
    </>
  );
};
